<template>
  <div class="home">
    <HolmyCalendar />    
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import HolmyCalendar from '@/components/HolmyCalendar.vue';

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    HolmyCalendar
  }
}
</script>
